import styled from "@emotion/styled";

export const PhoneNumberInputRow = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const CountryOption = styled.li`
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
`;
